import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/organizations";

export default class OrganizationService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
